import { motion } from "framer-motion";
import { brokerBenefits } from "@/data/brokerBenefits";
import { Card, CardContent } from "@/components/ui/card";

const BrokerValueSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 max-w-2xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-3">
            A inteligência que <span className="text-accent">trabalha pela sua carteira</span>
          </h2>
          <p className="text-muted-foreground font-body text-lg">
            Você continua no controle do cliente e da negociação. A plataforma faz o trabalho pesado de cruzar dados, identificar oportunidades e organizar sua operação.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {brokerBenefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <Card className="h-full border-border/60 hover:border-accent/40 transition-colors">
                <CardContent className="p-6">
                  <div className="w-11 h-11 rounded-xl bg-accent/10 flex items-center justify-center mb-4">
                    <b.icon className="text-accent" size={22} />
                  </div>
                  <h3 className="font-display font-semibold text-lg text-foreground mb-2">{b.title}</h3>
                  <p className="text-sm text-muted-foreground font-body leading-relaxed">{b.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrokerValueSection;